/* SOFIZARE – fotostrip op productkaarten (touch). Stippen volgen de scrollpositie; werkt na filteren/paginatie. */
(function(){
  var mq=window.matchMedia('(hover: none), (pointer: coarse), (max-width: 999px)');
  function active(gal){var t=gal.querySelector('[data-sz-gal-track]');return Math.round(t.scrollLeft/Math.max(1,t.clientWidth));}
  function sync(gal){var i=active(gal);gal.querySelectorAll('.sz-gal__dot').forEach(function(d,k){d.classList.toggle('is-active',k===i);});}
  document.addEventListener('scroll',function(e){
    var t=e.target; if(!t||!t.matches||!t.matches('[data-sz-gal-track]')) return;
    var g=t.closest('[data-sz-gal]'); if(g._szr) return;
    g._szr=requestAnimationFrame(function(){g._szr=0;sync(g);});
  },true);
  /* API voor de kleur-swatches: true = afgehandeld door de strip */
  window.szGalleryShow=function(card,mediaId,img){
    if(!mq.matches) return false;
    var gal=card&&card.querySelector('[data-sz-gal]'); if(!gal||getComputedStyle(gal).display==='none') return false;
    var t=gal.querySelector('[data-sz-gal-track]'), slides=t.children, idx=-1;
    for(var i=0;i<slides.length;i++){if(String(slides[i].dataset.mediaId)===String(mediaId)){idx=i;break;}}
    if(idx<0){var f=gal.querySelector('[data-sz-first]');if(f&&img){f.srcset=img.srcset;f.src=img.src;}idx=0;}
    t.scrollTo({left:idx*t.clientWidth,behavior:'smooth'});
    return true;
  };
})();
